<script>
  import { onMount } from "svelte";
  import MediaQuery from "svelte-media-query";
  import algoliasearch from "algoliasearch/lite";

  import DesktopMenu from "./DesktopMenu.svelte";
  import MobileMenu from "./MobileMenu.svelte";
  import Overlay from "./Overlay.svelte";
  import DesktopSearch from "./DesktopSearch.svelte";
  import MobileSearch from "./MobileSearch.svelte";
  import MenuTrigger from "./MenuTrigger.svelte";

  export let settings = {
    popularSearches: [],
    featuredProducts: [],
    navigationFeaturedProduct: {},
  };

  const client = algoliasearch(
    "U6BJKY9F7D",
    "72fb178dcbaa31e20a8b27d5d54db83a"
  );

  const searchIndexName = `sheertex.com_au`;
  const navigationFeaturedProduct = {
    ctaUrl: settings.featured_product_cta_url,
    ctaText: settings.featured_product_cta_text,
    label: settings.featured_product_label,
    imageSrc: settings.featured_product_image,
  };
  const navigationBottomLink = {
    text: settings.bottom_link_text,
    url: settings.bottom_link_url,
  };
  const menu = settings.menu;
  const searchSettings = {
    index: client.initIndex(searchIndexName),
    queryPlaceholder: settings.search_query_placeholder,
    clearButton: settings.search_clear_button,
    popularProductsTitle: settings.search_popular_products_title,
    popularQueriesTitle: settings.search_popular_queries_title,
    popularQueries: settings.search_popular_queries_list
      .split(";")
      .map((q) => q.trim()),
    popularProducts: settings.search_popular_products.map((product) => {
      return {
        ...product,
        imageSrc: product.featured_image,
        onlineStoreUrl: `/products/${product.handle}`,
      };
    }),
  };

  let node;
  let isSearchOpened = false;
  let isMenuOpened = false;

  const menuTrigger = document.querySelector("[data-svelte=menu-trigger]");
  const searchTrigger = document.querySelector("[data-svelte=search-trigger]");

  function setBodyOverflow(overflowType) {
    document.body.style.overflow = overflowType;
  }

  onMount(() => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });

    new MenuTrigger({
      target: menuTrigger,
      hydrate: false,
      props: {
        buttonText: settings.toggle_navigation,
      },
    });

    menuTrigger &&
      menuTrigger.addEventListener("click", () => {
        if (isMenuOpened || isSearchOpened) {
          closeMenu();
          closeSearch();
        } else {
          closeSearch();
          openMenu();
        }
      });

    searchTrigger &&
      searchTrigger.addEventListener("click", () => {
        if (isSearchOpened) {
          closeSearch();
        } else {
          closeMenu();
          openSearch();
        }
      });
  });

  function openMenu() {
    isMenuOpened = true;
    menuTrigger.classList.add("tw-underline");
    setBodyOverflow("hidden");
  }

  function closeMenu() {
    isMenuOpened = false;
    menuTrigger.classList.remove("tw-underline");
    setBodyOverflow("auto");
  }

  function openSearch() {
    isSearchOpened = true;
    setBodyOverflow("hidden");
  }

  function closeSearch() {
    isSearchOpened = false;
    setBodyOverflow("auto");
  }

  function closeAll() {
    closeMenu();
    closeSearch();
  }
</script>

{#if settings != null}
  <div bind:this={node}>
    {#if isMenuOpened || isSearchOpened}
      <Overlay onClick={closeAll} />
    {/if}

    <MediaQuery query="(max-width: 768px)" let:matches>
      {#if matches}
        {#if isMenuOpened}
          <MobileMenu
            menuItems={menu}
            openSearchDialog={() => {
              isSearchOpened = true;
              isMenuOpened = false;
            }}
            featuredProduct={navigationFeaturedProduct}
            bottomLink={navigationBottomLink}
          />
        {/if}
        {#if isSearchOpened}
          <MobileSearch
            onClose={() => {
              isSearchOpened = false;
              isMenuOpened = true;
            }}
            settings={searchSettings}
          />
        {/if}
      {:else}
        {#if isMenuOpened}
          <DesktopMenu
            menuItems={menu}
            featuredProduct={navigationFeaturedProduct}
            bottomLink={navigationBottomLink}
          />
        {/if}
        {#if isSearchOpened}
          <DesktopSearch onClose={closeAll} settings={searchSettings} />
        {/if}
      {/if}
    </MediaQuery>
  </div>
{/if}
